import React, { useEffect, useState } from 'react';
import styles from './index.module.scss';
import EPROInterviewItem from '../interviewItem';


interface InterviewItem {
    name: string;
    state: string;
    visitDate: string;
    planDate: string;
    id: number;
}

interface EPROInterviewListProps {
    list: InterviewItem[],
    onSelect?: ({(value: InterviewItem):void})
}

const EPROInterviewList = (props: EPROInterviewListProps) => {
    const [ currentIndex, setCurrentIndex ] = useState(0)
    const handleItemClick = (item: InterviewItem, index: number) => {
        sessionStorage.setItem('epro_visit_index', index + '') 
        setCurrentIndex(index)
        props.onSelect && props.onSelect(item)
    }
    useEffect(() => {
     
        if(props.list?.length){
            const index = props.list.findIndex((item: any) => ['Wait', 'Running'].includes(item.state))
            const indexCache = sessionStorage.getItem("epro_visit_index")
            if(indexCache){
                setCurrentIndex(Number(indexCache)) 
              
            }else{
                setCurrentIndex(index >= 0 ? index : 0)
            }
        }

    }, [props.list])
    return (
        <div className={styles.container}>
            {
                props.list?.length > 0 ? (
                    <>
                        <div className={styles.eproInterviewList}>
                            {props.list.map((item, index) =>
                                (<EPROInterviewItem
                                    key={item.id}
                                    
                                    state={item.state}
                                    name={item.name}
                                    date={item.state === 'Wait' ? item.planDate : item.visitDate}
                                    active={currentIndex===index}
                                    onSelect={() => handleItemClick(item, index)}
                                ></EPROInterviewItem>)
                            )}
                        </div>
                        <div className={styles.dotBar}>
                            {
                                props.list.map((item, index) =>
                                    <div key={item.id} className={`${styles.dotItem} ${currentIndex===index? styles.dotActive : ''}`}></div>
                                )
                            }
                        </div>
                    </>
                ) : ''
            }
            {
                props.list.length === 0 && (
                    <div className={styles.nodata}>您好，医生未完成对您的入排登记，项目暂未开放，请耐心等候</div>
                )
            }
        </div>
    )
}

export default EPROInterviewList